import { render, staticRenderFns } from "./shipintupian.vue?vue&type=template&id=1a22c6d8&scoped=true"
import script from "./shipintupian.vue?vue&type=script&lang=js"
export * from "./shipintupian.vue?vue&type=script&lang=js"
import style0 from "./shipintupian.vue?vue&type=style&index=0&id=1a22c6d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a22c6d8",
  null
  
)

export default component.exports